"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/internal-payment-ach-out.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Finternal-payment-ach-out.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.achOutInternalPaymentContextManualReviewStatusToJSON = exports.achOutInternalPaymentContextManualReviewStatusFromJSON = exports.AchOutInternalPaymentContextLinkedAccount = exports.AchOutInternalPaymentContextRiskScore = exports.AchOutInternalPaymentContext = exports.AchOutInternalPaymentContextManualReviewStatus = void 0;
const date_1 = require("../common/date");
const legal_name_1 = require("../common/legal-name");
const protobufPackage = 'com.step.common.proto';
var AchOutInternalPaymentContextManualReviewStatus;
(function (AchOutInternalPaymentContextManualReviewStatus) {
    AchOutInternalPaymentContextManualReviewStatus["INVALID_MANUAL_REVIEW_STATUS"] = "INVALID_MANUAL_REVIEW_STATUS";
    AchOutInternalPaymentContextManualReviewStatus["PENDING_MANUAL_REVIEW"] = "PENDING_MANUAL_REVIEW";
    AchOutInternalPaymentContextManualReviewStatus["MANUAL_REVIEW_APPROVED"] = "MANUAL_REVIEW_APPROVED";
    AchOutInternalPaymentContextManualReviewStatus["MANUAL_REVIEW_DENIED"] = "MANUAL_REVIEW_DENIED";
    AchOutInternalPaymentContextManualReviewStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(AchOutInternalPaymentContextManualReviewStatus || (exports.AchOutInternalPaymentContextManualReviewStatus = AchOutInternalPaymentContextManualReviewStatus = {}));
function createBaseAchOutInternalPaymentContext() {
    return {
        linkedAccount: undefined,
        stepAccountId: undefined,
        effectiveDate: undefined,
        requestedCommitTimeMs: '0',
        riskScore: undefined,
        manualReview: AchOutInternalPaymentContextManualReviewStatus.INVALID_MANUAL_REVIEW_STATUS,
    };
}
exports.AchOutInternalPaymentContext = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.linkedAccount)) {
            message.linkedAccount = exports.AchOutInternalPaymentContextLinkedAccount.fromJSON(object.linkedAccount);
        }
        if (isSet(object.stepAccountId)) {
            message.stepAccountId = globalThis.String(object.stepAccountId);
        }
        if (isSet(object.effectiveDate)) {
            message.effectiveDate = date_1.LocalDate.fromJSON(object.effectiveDate);
        }
        if (isSet(object.requestedCommitTimeMs)) {
            message.requestedCommitTimeMs = globalThis.String(object.requestedCommitTimeMs);
        }
        if (isSet(object.riskScore)) {
            message.riskScore = exports.AchOutInternalPaymentContextRiskScore.fromJSON(object.riskScore);
        }
        if (isSet(object.manualReview)) {
            message.manualReview = achOutInternalPaymentContextManualReviewStatusFromJSON(object.manualReview);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.linkedAccount !== undefined) {
            obj.linkedAccount = exports.AchOutInternalPaymentContextLinkedAccount.toJSON(message.linkedAccount);
        }
        if (message.stepAccountId !== undefined) {
            obj.stepAccountId = message.stepAccountId;
        }
        if (message.effectiveDate !== undefined) {
            obj.effectiveDate = date_1.LocalDate.toJSON(message.effectiveDate);
        }
        if (message.requestedCommitTimeMs !== undefined && message.requestedCommitTimeMs !== '0') {
            obj.requestedCommitTimeMs = message.requestedCommitTimeMs;
        }
        if (message.riskScore !== undefined) {
            obj.riskScore = exports.AchOutInternalPaymentContextRiskScore.toJSON(message.riskScore);
        }
        if (message.manualReview !== undefined &&
            message.manualReview !==
                AchOutInternalPaymentContextManualReviewStatus.INVALID_MANUAL_REVIEW_STATUS) {
            obj.manualReview = achOutInternalPaymentContextManualReviewStatusToJSON(message.manualReview);
        }
        return obj;
    },
    create(base) {
        return exports.AchOutInternalPaymentContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchOutInternalPaymentContext();
        message.linkedAccount = (object.linkedAccount !== undefined && object.linkedAccount !== null)
            ? exports.AchOutInternalPaymentContextLinkedAccount.fromPartial(object.linkedAccount)
            : undefined;
        message.stepAccountId = object.stepAccountId ?? undefined;
        message.effectiveDate = (object.effectiveDate !== undefined && object.effectiveDate !== null)
            ? date_1.LocalDate.fromPartial(object.effectiveDate)
            : undefined;
        message.requestedCommitTimeMs = object.requestedCommitTimeMs ?? '0';
        message.riskScore = (object.riskScore !== undefined && object.riskScore !== null)
            ? exports.AchOutInternalPaymentContextRiskScore.fromPartial(object.riskScore)
            : undefined;
        message.manualReview = object.manualReview ??
            AchOutInternalPaymentContextManualReviewStatus.INVALID_MANUAL_REVIEW_STATUS;
        return message;
    },
};
function createBaseAchOutInternalPaymentContextRiskScore() {
    return { score: 0, externalIndividualName: '', legalName: undefined };
}
exports.AchOutInternalPaymentContextRiskScore = {
    fromJSON(object) {
        const message = {
            score: isSet(object.score) ? globalThis.Number(object.score) : 0,
            externalIndividualName: isSet(object.externalIndividualName)
                ? globalThis.String(object.externalIndividualName)
                : '',
        };
        if (isSet(object.legalName)) {
            message.legalName = legal_name_1.LegalName.fromJSON(object.legalName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.score !== 0) {
            obj.score = message.score;
        }
        if (message.externalIndividualName !== '') {
            obj.externalIndividualName = message.externalIndividualName;
        }
        if (message.legalName !== undefined) {
            obj.legalName = legal_name_1.LegalName.toJSON(message.legalName);
        }
        return obj;
    },
    create(base) {
        return exports.AchOutInternalPaymentContextRiskScore.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchOutInternalPaymentContextRiskScore();
        message.score = object.score ?? 0;
        message.externalIndividualName = object.externalIndividualName ?? '';
        message.legalName = (object.legalName !== undefined && object.legalName !== null)
            ? legal_name_1.LegalName.fromPartial(object.legalName)
            : undefined;
        return message;
    },
};
function createBaseAchOutInternalPaymentContextLinkedAccount() {
    return { userId: '', externalAccountId: '' };
}
exports.AchOutInternalPaymentContextLinkedAccount = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.userId)) {
            message.userId = globalThis.String(object.userId);
        }
        if (isSet(object.externalAccountId)) {
            message.externalAccountId = globalThis.String(object.externalAccountId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== undefined && message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.externalAccountId !== undefined && message.externalAccountId !== '') {
            obj.externalAccountId = message.externalAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.AchOutInternalPaymentContextLinkedAccount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchOutInternalPaymentContextLinkedAccount();
        message.userId = object.userId ?? '';
        message.externalAccountId = object.externalAccountId ?? '';
        return message;
    },
};
function achOutInternalPaymentContextManualReviewStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_MANUAL_REVIEW_STATUS':
            return AchOutInternalPaymentContextManualReviewStatus.INVALID_MANUAL_REVIEW_STATUS;
        case 1:
        case 'PENDING_MANUAL_REVIEW':
            return AchOutInternalPaymentContextManualReviewStatus.PENDING_MANUAL_REVIEW;
        case 2:
        case 'MANUAL_REVIEW_APPROVED':
            return AchOutInternalPaymentContextManualReviewStatus.MANUAL_REVIEW_APPROVED;
        case 3:
        case 'MANUAL_REVIEW_DENIED':
            return AchOutInternalPaymentContextManualReviewStatus.MANUAL_REVIEW_DENIED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return AchOutInternalPaymentContextManualReviewStatus.UNRECOGNIZED;
    }
}
exports.achOutInternalPaymentContextManualReviewStatusFromJSON = achOutInternalPaymentContextManualReviewStatusFromJSON;
function achOutInternalPaymentContextManualReviewStatusToJSON(object) {
    switch (object) {
        case AchOutInternalPaymentContextManualReviewStatus.INVALID_MANUAL_REVIEW_STATUS:
            return 'INVALID_MANUAL_REVIEW_STATUS';
        case AchOutInternalPaymentContextManualReviewStatus.PENDING_MANUAL_REVIEW:
            return 'PENDING_MANUAL_REVIEW';
        case AchOutInternalPaymentContextManualReviewStatus.MANUAL_REVIEW_APPROVED:
            return 'MANUAL_REVIEW_APPROVED';
        case AchOutInternalPaymentContextManualReviewStatus.MANUAL_REVIEW_DENIED:
            return 'MANUAL_REVIEW_DENIED';
        case AchOutInternalPaymentContextManualReviewStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.achOutInternalPaymentContextManualReviewStatusToJSON = achOutInternalPaymentContextManualReviewStatusToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=internal-payment-ach-out.js.map